import { ContentType } from './ContentType';

export enum PermissionEnum {
  COVENANTS = 'ui:publisher:covenants',
  COVENANTS_DOC_SCORES_CUSIP_NA = 'ui:covenants:doc_scores:cusip:na',
  COVENANTS_DOC_SCORES_LOANX_EU = 'ui:covenants:doc_scores:loanx:eu',
  COVENANTS_DOC_SCORES_LOANX_NA = 'ui:covenants:doc_scores:loanx:na',
  NEWS = 'ui:publisher:news',
  RESEARCH = 'ui:publisher:research',
  STAFF = 'ui:admin:edit_articles',
  REDISTRIBUTION_ALLOWED = 'ui:redistribution_allowed',
  PRINT = 'ui:print',
  DOWNLOAD_CONTENT = 'ui:download_content',
  SHARE_CONTENT = 'ui:share_content',
  ASK_AN_ANALYST = 'ui:ask_an_analyst',
  COPY_PASTE = 'ui:copy_paste',
  RISK_PRODUCTS_EXTERNAL_LINK = 'ui:risk_products:external_link',
  FINANCIALS = 'ui:financials',
  FINANCIALS_DOWNLOAD_EXCEL = 'ui:financials:download:excel',
  // temp feature permissions
  RISK_PRODUCTS = 'ui:risk_products',
  DOCKETS = 'ui:dockets',
}

export const CONTENTTYPE_PERMISSIONS_MAP = {
  [ContentType.Research]: PermissionEnum.RESEARCH,
  [ContentType.Covenants]: PermissionEnum.COVENANTS,
  [ContentType.News]: PermissionEnum.NEWS,
};

export enum UserSubscription {
  CS_CR_LFI = 'CS_CR_LFI',
  CS_CR = 'CS_CR',
  CS_LFI = 'CS_LFI',
  CR_LFI = 'CR_LFI',
  CS = 'CS',
  CR = 'CR',
  LFI = 'LFI',
}

export interface PermissionDto {
  id: string;
  name: string;
  code: string;
}

export class UserPermissions {
  constructor(public permissions: string[], /** @deprecated */ public userSubscription: UserSubscription) {}

  hasAccessToDataTools(): boolean {
    return this.includes(PermissionEnum.COVENANTS);
  }

  hasAccessToMarkets(): boolean {
    return this.includes(PermissionEnum.RESEARCH);
  }

  hasAccessToMarketStats(): boolean {
    return this.includes(PermissionEnum.NEWS);
  }

  hasAccessToSpecialSituations(): boolean {
    return this.includesSome(PermissionEnum.RESEARCH, PermissionEnum.NEWS);
  }

  hasAccessToRP(): boolean {
    return this.includes(PermissionEnum.RISK_PRODUCTS);
  }

  /**
   * Checks if user effective permissions includes given permission
   * @param permission permission to check
   * @returns
   */
  includes(permission: PermissionEnum): boolean {
    return this.permissions?.includes(permission);
  }

  /**
   * Checks if user effective permissions includes at least one of given permissions
   * @param permission permissions to check
   * @returns
   */
  includesSome(...permissions: PermissionEnum[]): boolean {
    return permissions.some((p) => this.includes(p));
  }
}
